import { render } from "./InquiriesBar.vue?vue&type=template&id=4e45792c&ts=true"
import script from "./InquiriesBar.vue?vue&type=script&lang=ts"
export * from "./InquiriesBar.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__